import React from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

const EmailEmptyState = () => {
  return (
    <div className='flex items-center justify-center h-full min-h-[calc(100vh-475px)]'>
      <div className='text-center'>
        <EnvelopeIcon className='w-12 h-12 text-gray-400 mx-auto mb-4' />
        <p className='text-sm text-gray-500 font-medium'>No hay correos electrónicos</p>
        <p className='text-xs text-gray-400 mt-1'>Envía un email para iniciar la conversación</p>
      </div>
    </div>
  );
};

export default EmailEmptyState;
